<section class="text-image">

    <div class="container-redesign">

        <div class="text-image__content">

            <p
                *ngFor="let paragraph of paragraphs; trackBy: trackByIndex"
                class="text-image__paragraph">

                {{ paragraph }}

            </p>

        </div>

        <div class="text-image__image">

            <img
                [src]="image"
                [alt]="imageAlt">

        </div>

    </div>

</section>